<template>
  <div class="module">
    <el-date-picker
      class="date"
      v-model="month"
      type="monthrange"
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      range-separator="-"
      value-format="yyyy-MM"
      format="yyyy-MM"
      :clearable="false">
    </el-date-picker>
    <div class="chart" ref="chart"></div>
    <detail-list :showDialog.sync = "showDialog" :search="search"></detail-list>
  </div>
</template>

<script>
// import * as echarts from 'echarts'
import { px2vw } from '@/utils/util'
import DetailList from './DetailList.vue'
export default {
  name: 'Material',
  components: {
    DetailList
  },
  data () {
    return {
      month: '',
      showDialog: false,
      search: {
        outStartMonth: '',
        outEndMonth: '',
        detailedType: '2',
        projectId: '',
        materialTypeId: ''
      }
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId
    }
  },
  watch: {
    month () {
      this.loadData()
    },
    projectId () {
      this.loadData()
    }
  },
  created () {
    this._chart = {}
    this._list = {}
    this.month = [this.$dayjs().subtract(6, 'month').format('YYYY-MM'), this.$dayjs().format('YYYY-MM')]
  },
  destoryed () {
    this._chart.getZr().off('click')
    this._chart.dispose()
  },
  methods: {
    loadData () {
      this.$axios.get(this.$apis.material.selectYhOutDetailedSum, {
        outStartMonth: this.month[0],
        outEndMonth: this.month[1],
        projectId: this.projectId
      }).then(res => {
        this._list = res
        const x = res.map(item => item.materialTypeName)
        const y = res.map(item => item.operationStock)
        this.renderChart(x, y, 'chart')
      })
    },
    renderChart (xAxis, yAxis, ref) {
      this._chart = echarts.init(this.$refs[ref])
      const option = {
        title: {
          text: '物料用量统计图',
          textStyle: {
            align: 'center',
            color: '#000000',
            fontSize: 12
          },
          top: px2vw(10),
          left: 'center'
        },
        grid: {
          top: px2vw(60),
          left: px2vw(40),
          bottom: px2vw(40),
          right: 0
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          }
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: false, // 隐藏X轴轴线
            lineStyle: {
              color: '#01FCE3'
            }
          },
          axisTick: {
            show: false // 隐藏X轴刻度
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#000000'
            },
            interval: 0
          },
          data: xAxis
        },
        yAxis: {
          name: '个',
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#000000'
            },
            formatter: (item) => {
              return item.length > 9 ? item.substring(0, 4) + '...' + item.substring(item.length - 4, item.length) : item
            }
          }
        },
        series: [
          {
            data: yAxis,
            type: 'bar',
            barWidth: px2vw(20),
            itemStyle: {
              // 折线拐点标志的样式
              color: '#006FFF'
            }
          }
        ],
        dataZoom: {
          show: xAxis.length > 5,
          type: 'slider',
          borderColor: 'transparent',
          backgroundColor: '#D9D9D9',
          fillerColor: '#2275D3',
          handleStyle: {
            opacity: 0
          },
          bottom: px2vw(10),
          height: px2vw(6),
          start: 0,
          end: 50,
          showDetail: false,
          showDataShadow: false,
          brushSelect: false
        }
      }
      this._chart.clear()
      this._chart.getZr().off('click')
      if (xAxis.length === 0) {
        const img = require('@/assets/icon/empty.svg')
        this._chart.setOption({
          graphic: {
            elements: [{
              type: 'image',
              style: {
                image: img,
                width: 128,
                height: 117
              },
              left: 'center',
              top: 'center'
            }]
          }
        })
      } else {
        this._chart.setOption(option)
      }
      this._chart.getZr().on('click', (params) => {
        const pointInPixel = [params.offsetX, params.offsetY]
        if (this._chart.containPixel('grid', pointInPixel)) {
          const xIndex = this._chart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0]
          this.showDialog = true
          this.search.outStartMonth = this.month[0]
          this.search.outEndMonth = this.month[1]
          this.search.projectId = this.projectId
          this.search.materialTypeId = this._list[xIndex].materialTypeId
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.module{
  padding: 10px 6px;
}
.chart{
  width: calc(100% - 20px);
  height: 200px;
  margin-top: 10px;
}
</style>
